/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAssetsDepositSourceQueryVariables = Types.Exact<{
  softwareEscrowId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  type?: Types.InputMaybe<Types.AssetTypeEnum>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type IAssetsDepositSourceQuery = {
  __typename?: 'Query';
  assetsSource: {
    __typename?: 'AssetPage';
    nodes: Array<{
      __typename?: 'Asset';
      id: string;
      externalId?: string | null;
      depositSource?: string | null;
      type: Types.AssetTypeEnum;
      integration?:
        | { __typename?: 'CustomIntegration'; id: string }
        | { __typename?: 'OauthIntegration'; id: string }
        | { __typename?: 'ShareFileIntegration'; id: string }
        | null;
    }>;
  };
};

export const AssetsDepositSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assetsDepositSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'assetsSource' },
            name: { kind: 'Name', value: 'assets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'softwareEscrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'page' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'asset_type' },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'order' }, value: { kind: 'EnumValue', value: 'asc' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'integration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAssetsDepositSourceQuery, IAssetsDepositSourceQueryVariables>;
